var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      attrs: { shadow: "hover" },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c("div", { staticClass: "card-header" }, [
                _c("span", [_vm._v(_vm._s(_vm.plan.displayName))]),
                _vm._v(" "),
                _c("div", { staticClass: "price" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.generateDisplayPrice(
                          _vm.plan,
                          _vm.subscriptionPeriod
                        )
                      ) +
                      "\n          "
                  ),
                  _c("div", { staticClass: "price-details" }, [
                    _c("span", { staticClass: "currency" }, [_vm._v("AUD")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "period" }, [
                      _vm._v(
                        "/" +
                          _vm._s(
                            _vm.subscriptionPeriod === "MONTHLY" ? "mo" : "yr"
                          )
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.plan.uconnectSubscription.productCode != "UCON_STND_FREE"
                  ? _c("div", { staticClass: "billed" }, [
                      _vm._v(
                        "billed " +
                          _vm._s(
                            _vm.subscriptionPeriod === "MONTHLY"
                              ? "monthly"
                              : "annually"
                          )
                      )
                    ])
                  : _c("div", { staticClass: "billed free" }),
                _vm._v(" "),
                _vm.plan.uconnectSubscription.productCode === "UCON_STND_BAS" ||
                _vm.plan.uconnectSubscription.productCode === "UCON_STND_PRO" ||
                _vm.plan.uconnectSubscription.productCode ===
                  "UCON_STND_ELITE" ||
                _vm.plan.uconnectSubscription.productCode ===
                  "UCON_STND_ELITE_NEW"
                  ? _c("div", { staticClass: "billed annual" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.generateAlternateDisplayPrice(
                              _vm.plan,
                              _vm.subscriptionPeriod
                            )
                          ) +
                          " /" +
                          _vm._s(
                            _vm.subscriptionPeriod != "MONTHLY"
                              ? "monthly"
                              : "annually"
                          )
                      )
                    ])
                  : _vm.plan.uconnectSubscription.productCode ===
                    "UCON_CORP_PREM"
                  ? _c("div", { staticClass: "billed annual" }, [
                      _vm._v(
                        " Custom AUD /" +
                          _vm._s(
                            _vm.subscriptionPeriod != "MONTHLY"
                              ? "monthly"
                              : "annually"
                          )
                      )
                    ])
                  : _c("div", { staticClass: "billed free" })
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v(_vm._s(_vm.getDescription(_vm.plan.uconnectSubscription.info)))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "features", staticStyle: { "min-height": "100px" } },
        [
          _c(
            "ul",
            _vm._l(
              _vm.getFeatureList(_vm.plan.uconnectSubscription.info),
              function(feature, index) {
                return _c(
                  "li",
                  { key: index },
                  [
                    _vm.isString(feature)
                      ? [
                          _c("i", { staticClass: "el-icon-check" }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: { innerHTML: _vm._s(feature) }
                          })
                        ]
                      : Array.isArray(feature)
                      ? [
                          _c(
                            "ul",
                            _vm._l(feature, function(item, index) {
                              return _c("li", { key: index }, [
                                _c("i", { staticClass: "el-icon-check" }),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: { innerHTML: _vm._s(item) }
                                })
                              ])
                            }),
                            0
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              }
            ),
            0
          )
        ]
      ),
      _vm._v(" "),
      _vm.plan.uconnectSubscription.subscriptionType === "U_CON_CORP"
        ? _c(
            "el-button",
            {
              staticClass: "action-btn",
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.contactUs()
                }
              }
            },
            [_vm._v("Contact us")]
          )
        : _c(
            "el-button",
            {
              staticClass: "action-btn",
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.subscribeNow(_vm.plan.uconnectSubscription.id)
                }
              }
            },
            [_vm._v("Sign up now")]
          ),
      _vm._v(" "),
      _vm.requestToJoinDialogVisible
        ? _c("request-to-join-u-connect-corporate-dialog", {
            attrs: {
              "request-to-join-dialog-visible": _vm.requestToJoinDialogVisible
            },
            on: {
              onClose: function($event) {
                _vm.requestToJoinDialogVisible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16904848", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16904848","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/selectPackage/packageCard.vue
// module id = null
// module chunks = 